var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"task-result",class:_vm.resultData.status},[_c('div',{staticClass:"result-content"},[_c('i',{staticClass:"result-icon",class:_vm.resultIcon}),_c('span',{staticClass:"result-message"},[_vm._v(_vm._s(_vm.resultData.message))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }